// #region Imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { WelcomeModel, ApplicationError, ErrorMessage } from '../../../models';
import { AppService } from '../app.service';
import { WelcomeBaseService } from './welcome-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class WelcomeService extends WelcomeBaseService {

  private campaignId: string | undefined;

  constructor(
    private http: HttpClient,
    protected appService: AppService,
    private translate: TranslateService,
  ) {
    super();
  }

  public loadData(campaignId: string): void {
    if (!campaignId || campaignId === this.campaignId){
      return;
    }

    const url =
        environment.apiConfig.surveyApiUrl +
        environment.apiConfig.welcomeApi +
        `/${campaignId}`;

    this.appService.setLoading(true);

    this.http.get<WelcomeModel>(url)
    .pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._error.bind(this))
    )
    .subscribe((welcome: WelcomeModel | null) => {
      this._welcomeModel$.next(welcome);
      this.appService.setLoading(false);
      if (welcome) {
        this.campaignId = campaignId;
      }
    });
  }

  private _error(err: any): Observable<WelcomeModel | null> {
    this._handleError(err);
    return of(null);
  }

  private _handleError(err: any) {
    this.appService.setLoading(false);

    const error: ApplicationError = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'WelcomeService',
      false,
      err
    );

    this.appService.setLastError(error);

    this._welcomeModel$.next(null);
  }
}
